export default "__VITE_PUBLIC_ASSET__0f6481eb__"